import { useTranslation } from "react-i18next";

export const OcCurrencyComponent = ({
  value,
  children,
}: {
  value: number;
  children?: React.ReactNode;
}) => {
  const { i18n } = useTranslation();
  let currency = new Intl.NumberFormat(i18n.language, {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    style: "currency",
    currency: "HUF",
  }).format(value);
  return (
    <span>
      {currency} {children}
    </span>
  );
};

export const OcCurrency = ({ value }: { value: number }) => {
  const { i18n } = useTranslation();
  let currency = new Intl.NumberFormat(i18n.language, {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    style: "currency",
    currency: "HUF",
  }).format(value);
  return currency;
};

export default OcCurrency;
